import type { QueryClient } from '@tanstack/react-query';

/* ==========================================================================
   Chaves de cache do canal WhatsApp, por estabelecimento

   Ficam fora de useWhatsapp.ts para a conexão de pedidos (useOrdersSignalR)
   revalidar o status sem carregar os hooks do canal, como billing-keys.ts.
   ========================================================================== */

export const whatsappKeys = {
  root: (tenantId: string) => ['whatsapp', tenantId] as const,
  status: (tenantId: string) => [...whatsappKeys.root(tenantId), 'status'] as const,
};

/**
 * `whatsapp.connection_updated` é campainha: o painel relê
 * `GET /whatsapp/status` e nunca lê o estado do próprio evento.
 */
export function invalidateWhatsappStatus(queryClient: QueryClient, tenantId: string): void {
  if (!tenantId) return;
  void queryClient.invalidateQueries({ queryKey: whatsappKeys.status(tenantId) });
}
